import React from 'react';
export interface SectionTitleCardProps {
  variant?: string;
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  align?: string;
  className?: string;
}
const SectionTitleCard: React.FC<SectionTitleCardProps> = ({ eyebrow, title, subtitle, align = 'center', className = '' }) => (
  <div className={`section-title-card ${className}`} style={{ textAlign: align as any, marginBottom: 'var(--spacing-10)' }}>
    {eyebrow && <p style={{ color: 'var(--color-primary)', fontSize: 'var(--font-size-sm)', fontWeight: 'var(--font-weight-semibold)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 'var(--spacing-2)' }}>{eyebrow}</p>}
    {title && <h2 style={{ fontSize: 'var(--font-size-3xl)', fontWeight: 'var(--font-weight-bold)', marginBottom: subtitle ? 'var(--spacing-3)' : 0 }}>{title}</h2>}
    {subtitle && <p style={{ fontSize: 'var(--font-size-lg)', color: 'var(--color-text-muted)', maxWidth: '640px', margin: '0 auto' }}>{subtitle}</p>}
  </div>
);
export default SectionTitleCard;
